export class brandConfig {
    static   brand;
    static   locale;
    static   apikey;    
}

